import { doc, getDoc, runTransaction, setDoc } from 'firebase/firestore';
import { useContext, useEffect, useMemo } from 'react';
import { useDocumentOnce } from 'react-firebase-hooks/firestore';
import { FirebaseAppContext, FirebaseAuthContext } from 'libs.firebase_react';
import { CodedError } from 'libs.localization.common';
import { Localization } from 'libs.localization.web';
export function useProductLocalization(id) {
    const { db } = useContext(FirebaseAppContext);
    const { loading: loadingAuth, error: errorAuth } = useContext(FirebaseAuthContext);
    const localization = useMemo(() => getLocalization(id), [id]);
    const localizationQuery = useMemo(() => {
        if (!db || !localization || loadingAuth) {
            return null;
        }
        return doc(db, `localization`, localization.getId());
    }, [db, loadingAuth, localization]);
    useEffect(() => {
        if (db && localization && !loadingAuth) {
            localization.configureLocalizationDatabase(doc, getDoc, setDoc, null, null, null, null, runTransaction, db, '');
        }
    }, [db, loadingAuth, localization]);
    const [snapshot, , errorFirestore] = useDocumentOnce(localizationQuery, {
        getOptions: { source: 'server' },
    });
    const entry = (snapshot === null || snapshot === void 0 ? void 0 : snapshot.data()) || {};
    const error = errorAuth || errorFirestore;
    // react-firebase-hooks briefly retains loading=false while a query changes from null to a document reference.
    // A snapshot (including a missing-document snapshot) or an error is the reliable terminal state for this read.
    const isLoading = loadingAuth || Boolean(localizationQuery && snapshot === undefined && !error);
    return {
        isLoading,
        localization,
        localizationEntry: entry,
        error,
    };
}
function getLocalization(id) {
    if (!id) {
        return undefined;
    }
    try {
        return new Localization(id);
    }
    catch (error) {
        if (error instanceof CodedError && error.code === 'E_ASSET_NOT_SUPPORTED') {
            console.error(`Unsupported asset: ${error.message}`, id);
            return undefined;
        }
        throw error;
    }
}
//# sourceMappingURL=product_localization.hook.js.map